import './App.css';
import React, { Suspense, useContext } from 'react';
import { 
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate
} from 'react-router-dom';
import { ToastContainer } from './utils/toast';
import { AuthProvider } from "./context/authContext";
import { ThemeProvider } from './context/themeContext';
import { LanguageProvider } from './context/languageContext';
import { ContributorProfileProvider } from 'context/contributorProfileContext';
import history from '@history';

import Home01 from './pages/Home01';
import routes from './pages/index';

function App() {

    return (
        <AuthProvider>
            <ContributorProfileProvider>
                <ThemeProvider>
                    <LanguageProvider>
                        <Suspense fallback={<div>Loading</div>}>
                            <Routes history={history}>
                                {
                                    routes.map((data,index) => (
                                        <Route onUpdate={() => window.scrollTo(0, 0)} exact={true} path={data.path} element={data.component} key={index} />
                                        ))
                                    }
                            </Routes>
                            <ToastContainer />

                        </Suspense>
                    </LanguageProvider>
                </ThemeProvider>
            </ContributorProfileProvider>
        </AuthProvider>
        
    );
}

export default App;
